import { render, staticRenderFns } from "./MedicalRequirementsPlanRaysEdit.vue?vue&type=template&id=1280ae9a&scoped=true&"
import script from "./MedicalRequirementsPlanRaysEdit.vue?vue&type=script&lang=js&"
export * from "./MedicalRequirementsPlanRaysEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1280ae9a",
  null
  
)

export default component.exports